export enum Actions {
  SET_GROUPING = '@@equipmentGrouping/SET_GROUPING',
}

export const setEquipmentGrouping = (groupType: string) => ({
  type: Actions.SET_GROUPING,
  payload: groupType,
});
